import * as React from "react";
import PivotTable from "../pivot-table/PivotTable";

const PivotTableRoute: React.FC = () => {
    return (
        <div>
            <PivotTable />
        </div>
    )
}

export default PivotTableRoute;